<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="d-flex justify-content-between">
  <app-breadcrumb id="MainActivity" *ngIf="qualityService.refereshBreadCrumb"></app-breadcrumb>
  <div class="d-flex gap-4 align-items-center">
    <div *ngIf="qualityService.activity.status" class="">
      <span class="crDetail-status1" *ngIf="qualityService.activity != undefined"
        [ngStyle]="statusAppearance(qualityService.activity.status)">
        Status&nbsp;:&nbsp; <span>{{ this.qualityService.activity.status }}</span>
      </span>
    </div>
    <div class="d-flex gap-2">
      <div class="d-flex align-items-center justify-content-center communication_cta pointer"
        (click)="openExportPopup()" matTooltip="Report" (keydown.enter)="openExportPopup()">
        <img src="../../../assets/img/cr_module/pdf.svg" width="11px" height="15px" alt="" />
      </div>
      <div class="d-flex align-items-center justify-content-center communication_cta  pointer"
        matTooltip="Dependent of">
        <img src="../../../assets/img/qms_img/dependency.svg" width="14px" height="14px" alt=""
          (click)="openDependentsPopup()" (keydown.enter)="openDependentsPopup()" />
      </div>
      <div *ngIf="message.isTopicAdministrator">
        <div class="d-flex align-items-center justify-content-center communication_cta  pointer"
          matTooltip="Communication">
          <img src="../../../assets/img/cr_module/communication.svg" width="14px" height="14px" alt=""
            (click)="openTopicPopup()" (keydown.enter)="openTopicPopup()" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center communication_cta communication-icon pointer"
        matTooltip="Tag to Home" (click)="openTag()" (keydown.enter)="openTag()">
        <img src="../../../assets/img/tags.png" width="17px" height="19px" alt="" />
      </div>
    </div>
  </div>
</div>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="d-flex mt-2 mb-2">
  <div class="" style="margin-right:auto;">
    <app-task-stage-statistics *ngIf="qualityService.refereshBreadCrumb"></app-task-stage-statistics>
  </div>
  <div class="" style="margin-right:1%;align-content:center;"
    *ngIf="(qualityService.activity.status == 'In Progress' || qualityService.activity.status == 'PhaseII In Progress' || qualityService.activity.status == 'PhaseIII In Progress') && parallelWorkflowList?.length==0 && (qualityService.activity.owner == qualityService.loggeduserid)">
    <div matTooltip="Add Workflow" (click)="openAddWorkflow()" (keydown.enter)="openAddWorkflow()"
      style="border: 0.75px solid rgba(222, 235, 254, 0.8980392157); border-radius: 100px; width: 36px; height: 36px;"
      class="d-flex justify-content-center align-items-center actions_cta pointer">
      <a>
        <img title="Switch User" src="..//..//../assets/img/parallel workflow.svg" alt="parallel-workflow" width="20"
          height="20">
      </a>
    </div>
  </div>
  <div class="">
    <div class="">
      <app-activity-dynamic-button></app-activity-dynamic-button>
    </div>
  </div>
</div>

<div class="tab">
  <mat-tab-group selectedIndex="0" mat-stretch-tabs class="activitytab mat-tab-container mat-elevation-z4"
    *ngIf="dynamicLabel" animationDuration="0ms" (selectedTabChange)="onTabChanged($event);"
    [(selectedIndex)]="selectedTabIndex" #tabsGroup>
    <!-- OSS Main Tab -->
    <mat-tab label="OOS">
      <!-- Tab Header -->
      <ng-template mat-tab-label>
        <span>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.14999 4.9501L8.4877 8.64544C8.7959 8.85881 9.20408 8.85881 9.51228 8.64544L14.85 4.9501M3.59999 14.4001H14.4C15.3941 14.4001 16.2 13.5942 16.2 12.6001V5.4001C16.2 4.40599 15.3941 3.6001 14.4 3.6001H3.59999C2.60588 3.6001 1.79999 4.40599 1.79999 5.4001V12.6001C1.79999 13.5942 2.60588 14.4001 3.59999 14.4001Z"
              stroke="#005C8A" [ngStyle]="{strokeWidth: selectedTab == 'Change Request' ? '2' : ''}"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        &nbsp;<span>{{oos?.oostType}}</span>
      </ng-template>
      <!-- Tab Body -->
      <div class="row" *ngIf="dynamicLabel">

        <!-- Initial Details  -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Initial Details</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-3">
              <div>
                <!-- OOS ID -->
                <label for="oos-id">
                  {{qualityService.activity.oostType}}&nbsp;{{dynamicLabel['OOS_ID']?.fieldName}}
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['OOS_ID']?.fieldNotes"
                  [matTooltip]="dynamicLabel['OOS_ID'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input id="cc-id" class="input-filed-continers disabled-input" type="text"
                [(ngModel)]="qualityService.activity.oosId" [matTooltip]="qualityService.activity.oosId"
                [disabled]="true">
            </div>

            <div class="col-md-3" [hidden]="dynamicLabel['INITIATED_ON'].isRemovable=='Y'">
              <div>
                <!-- Initiated On -->
                <label for="created-on">
                  {{dynamicLabel['INITIATED_ON'].fieldName}}
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['INITIATED_ON'].fieldNotes"
                  [matTooltip]="dynamicLabel['CREATED_ON'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input id="created-on" type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="qualityService.activity.initiatedOn" [disabled]="true">
            </div>

            <div class="col-md-3">
              <div>
                <!-- Initiated By -->
                <label id="initiator" for="initiator">
                  {{dynamicLabel['INITIATED_BY_USER_NAME'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['INITIATED_BY_USER_NAME']?.fieldNotes"
                  [matTooltip]="dynamicLabel['INITIATED_BY_USER_NAME']?.fieldNotes"><img [src]="qualityService.noteIcon"
                    alt="note" width="18" height="18"></span>
              </div>
              <input id="initiator-user" class="input-filed-continers disabled-input" type="text"
                [(ngModel)]="qualityService.activity.initiatedByUserName" [disabled]="true">
            </div>

            <div class="col-md-3" [hidden]="dynamicLabel['INITIATING_DEPT_NAME'].isRemovable=='Y'">
              <div>
                <!-- Initiating Department -->
                <label id="initiating-department" for="initiating-department">
                  {{dynamicLabel['INITIATING_DEPT_NAME'].fieldName}}</label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['INITIATING_DEPT_NAME'].fieldNotes"
                  [matTooltip]="dynamicLabel['INITIATING_DEPT_NAME'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select" (keydown.enter)="focusSearch('initiating-department-search')"
                [(ngModel)]="qualityService.activity.initiatingDeptCode" (closed)="InitiatingDepartmentSearchText=''"
                (click)="focusSearch('initiating-department-search')" [disabled]="message.isInitiationFrozen">
                <input type="search" id="initiating-department-search" class="dropdownsearchstyle"
                  [(ngModel)]="InitiatingDepartmentSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onInitiatingDepartmentSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of departmentDropDown| assessmentSearch :InitiatingDepartmentSearchText"
                  (onSelectionChange)="onInitiatingDepartmentSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div>
                <!-- Initiated By -->
                <label id="analyser" for="email">
                  {{dynamicLabel['ANALYSED_BY_USER'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label
                  *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qualityService.activity.status,'analysedBy')"
                  for="email">
                  <a (click)="openswitchuser('Analyser')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="switch" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['ANALYSED_BY_USER	']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ANALYSED_BY_USER	']?.fieldNotes"><img [src]="qualityService.noteIcon"
                    alt="note" width="18" height="18"></span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="qualityService.activity.analysedBy"
                (closed)="analyserSearchText=''" (click)="focusSearch('analyser-search')"
                (keydown.enter)="focusSearch('analyser-search')" [disabled]="message.isInitiationFrozen">
                <input type="search" id="analyser-search" class="dropdownsearchstyle" [(ngModel)]="analyserSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onAnalyserSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of analyserDropDown| assessmentSearch :analyserSearchText"
                  (onSelectionChange)="onAnalyserSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div>
                <label id="oos-occurrence" for="email">
                  {{dynamicLabel['DATE_OF_OCCURRENCE']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['DATE_OF_OCCURRENCE']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DATE_OF_OCCURRENCE']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="$past_present_config" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="qualityService.activity.dateOfOccurrence"
                (ngModelChange)="onOosOccurrenceChange(); onNgModelChange(oos.dateOfOccurrence, 'oos-occurrence')"
                [disabled]="message.isInitiationFrozen">
            </div>

            <div class="col-md-3">
              <div>
                <label id="oos-identified-on" for="email">
                  {{dynamicLabel['IDENTIFIED_ON']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['IDENTIFIED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IDENTIFIED_ON']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="$identified_on_dynamic_config()" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="qualityService.activity.identifiedOn"
                (ngModelChange)="onNgModelChange(oos.identifiedOn, 'oos-identified-on'); getDelayLoggingMandatory()"
                [disabled]="message.isInitiationFrozen">
            </div>

            <div class="col-md-3" [hidden]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.isRemovable=='Y'">
              <div>
                <label id="expected-to-be-started-on" for="email">
                  {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON']?.fieldNotes"><img
                    [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="expectedToBeStartedOnConfig" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="qualityService.activity.expectedToBeStartedOn"
                (ngModelChange)="calcTimeZone($event); onExpectedToBeStartedOnChange(); onNgModelChange(qualityService.activity.expectedToBeStartedOn, 'expected-to-be-started-on')"
                [disabled]="message.isInitiationFrozen">
            </div>

            <div class="col-md-3">
              <div>
                <!-- Expected Closure On -->
                <label id="expected-closure-on" for="email">
                  {{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
                  [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="getExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="qualityService.activity.expcetedClosureOn"
                (ngModelChange)="onNgModelChange(qualityService.activity.expcetedClosureOn, 'expected-closure-on')"
                [disabled]="message.isInitiationFrozen">
            </div>

            <div class="col-md-3">
              <div>
                <!-- Owner -->
                <label id="owner" for="email">
                  {{dynamicLabel['OWNER_USER_NAME'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qualityService.activity.status,'owner')"
                  for="email">
                  <a (click)="openswitchuser('Owner')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="switch" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['OWNER_USER_NAME'].fieldNotes"
                  [matTooltip]="dynamicLabel['OWNER_USER_NAME'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="qualityService.activity.owner"
                (closed)="ownerSearchTxt=''" (click)="focusSearch('owner-search')"
                (keydown.enter)="focusSearch('owner-search')" [disabled]="message.isInitiationFrozen">
                <input type="search" id="owner-search" class="dropdownsearchstyle" [(ngModel)]="ownerSearchTxt" matInput
                  placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onOwnerSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of ownerDropDown| assessmentSearch :ownerSearchTxt"
                  (onSelectionChange)="onOwnerSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" *ngIf="qualityService.activity.startedOn">
              <div>
                <!-- Started On -->
                <label for="email">{{dynamicLabel['STARTED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['STARTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['STARTED_ON']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="commonDateConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qualityService.activity.startedOn"
                [disabled]="true">
            </div>

            <div class="col-md-3" *ngIf="qualityService.activity.completedOn">
              <div>
                <!-- Completed On -->
                <label for="email">
                  {{!dynamicLabel['COMPLETED_ON'] ? "Completed On" : dynamicLabel['COMPLETED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['COMPLETED_ON']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="commonDateConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qualityService.activity.completedOn"
                [disabled]="true">
            </div>

            <div class="col-md-6" [hidden]="dynamicLabel['JUSTIFICATION_IN_DELAY_LOGGING']?.isRemovable=='Y'">
              <div>
                <!-- Delay Logging -->
                <label id="delay-logging" for="email">
                  {{dynamicLabel['JUSTIFICATION_IN_DELAY_LOGGING']?.fieldName}}
                </label>
                <span *ngIf="markDelayLoggingAsMandatory" class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['JUSTIFICATION_IN_DELAY_LOGGING']?.fieldNotes"
                  [matTooltip]="dynamicLabel['JUSTIFICATION_IN_DELAY_LOGGING']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.justificationInDelayLogging" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isInitiationFrozen"
                    (ngModelChange)="onStEditorChange($event,'delay-logging')" (paste)="onPaste($event)"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isInitiationFrozen ? openEditor('Justification In Delay Logging', 'eye') : openEditor('Justification In Delay Logging', 'edit')"
                  (click)="message.isInitiationFrozen ? openEditor('Justification In Delay Logging', 'eye') : openEditor('Justification In Delay Logging', 'edit')">
                  <i *ngIf="!message.isInitiationFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isInitiationFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

          </div>
        </fieldset>

        <!--  Location Details -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Location Details</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-3" [hidden]="dynamicLabel['OOS_DEPT_NAME'].isRemovable=='Y'">
              <div>
                <!-- OOS Department -->
                <label id="department" for="email">
                  {{dynamicLabel['OOS_DEPT_NAME'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['OOS_DEPT_NAME'].fieldNotes"
                  [matTooltip]="dynamicLabel['OOS_DEPT_NAME'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="qualityService.activity.oosDeptCode"
                (closed)="departmentSearchText=''" (click)="focusSearch('department-search')"
                (keydown.enter)="focusSearch('department-search')" [disabled]="message.isInitiationFrozen">
                <input type="search" id="department-search" class="dropdownsearchstyle"
                  [(ngModel)]="departmentSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onDepartmentSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of departmentDropDown| assessmentSearch :departmentSearchText"
                  (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div>
                <!-- Location -->
                <label id="location" for="location-details">
                  Location Name
                </label>
              </div>
              <mat-select matInput placeholder="Select" (keydown.enter)="focusSearch('location-search')"
                [ngClass]="{'odd-item-mat-select': oddLocation == qualityService.activity.locationId}"
                [(ngModel)]="qualityService.activity.locationId" [disabled]="message.isInitiationFrozen"
                (closed)="locationSearchText=''" (click)="focusSearch('location-search')">
                <input type="search" id="location-search" class="dropdownsearchstyle" [(ngModel)]="locationSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" (onSelectionChange)="onLocationSelect($event,null)"
                  [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of locationDropDown | assessmentSearch : locationSearchText"
                  (onSelectionChange)="onLocationSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" *ngIf="isLocationIfOthers">
              <div>
                <!-- Operating Unit -->
                <label for="email">
                  {{dynamicLabel['LOCATION_IF_OTHERS'].fieldName}}&nbsp;
                </label> <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['LOCATION_IF_OTHERS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['LOCATION_IF_OTHERS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input type="text" class="input-filed-continers" [(ngModel)]="qualityService.activity.locationIfOthers"
                  [disabled]="message.isInitiationFrozen">
              </div>
            </div>

            <div class="col-md-3">
              <div>
                <!-- Operating Unit -->
                <label id="operating-unit" for="email">
                  {{dynamicLabel['OPERATING_UNIT'].fieldName}}&nbsp;
                </label>
                <span style="float:right" *ngIf="dynamicLabel['OPERATING_UNIT']?.fieldNotes"
                  [matTooltip]="dynamicLabel['OPERATING_UNIT']?.fieldNotes"><img [src]="qualityService.noteIcon"
                    alt="note" width="18" height="18"></span>
              </div>
              <div class="row">
                <input class="input-filed-continers operatingUnit" type="text"
                  [matTooltip]="qualityService.activity.operatingUnit"
                  [(ngModel)]="qualityService.activity.operatingUnit" [disabled]="message.isInitiationFrozen">
              </div>
            </div>
          </div>
        </fieldset>

        <!-- Description  -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Description</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-6">
              <div>
                <!-- Short Description -->
                <label id="short-description" for="email">
                  {{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}
                  <span class="mandatory-symbol">*</span>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['SHORT_DESCRIPTION']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row" style="margin-top: 2%;">
                <input class="input-filed-continers shortDescription" type="text"
                  [matTooltip]="qualityService.activity.shortDescription" [disabled]="message.isInitiationFrozen"
                  (input)="limitCharacters($event, 'SHORT_DESCRIPTION')"
                  [(ngModel)]="qualityService.activity.shortDescription"
                  (ngModelChange)="onNgModelChange(qualityService.activity.shortDescription, 'short-description')">
              </div>
            </div>

            <div class="col-md-6" [hidden]="dynamicLabel['OOS_DESCRIPTION']?.isRemovable=='Y'">
              <div>
                <!-- Description -->
                <label id="description" for="email">
                  {{dynamicLabel['OOS_DESCRIPTION']?.fieldName}}
                  <span class="mandatory-symbol">*</span>
                  <span style="float:right" *ngIf="dynamicLabel['OOS_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['OOS_DESCRIPTION']?.fieldNotes">
                    <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </label>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.oosDescription" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isInitiationFrozen" (paste)="onPaste($event)"
                    (ngModelChange)="onStEditorChange(qualityService.activity.oosDescription, 'description')"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isInitiationFrozen ? openEditor(' Brief Description', 'eye') : openEditor('Brief Description', 'edit')"
                  (click)="message.isInitiationFrozen ? openEditor(' Brief Description', 'eye') : openEditor('Brief Description', 'edit')">
                  <i *ngIf="!message.isInitiationFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isInitiationFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div>
                <!-- Product or Material Name -->
                <label id="product-or-material-name" for="email">
                  {{dynamicLabel['PRODUCT_OR_MATERIAL_NAME'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['PRODUCT_OR_MATERIAL_NAME']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PRODUCT_OR_MATERIAL_NAME']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select" (keydown.enter)="focusSearch('focus-product-search')"
                [(ngModel)]="qualityService.activity.productOrMaterialName"
                (click)="focusSearch('focus-product-search')" [disabled]="message.isInitiationFrozen">
                <input type="search" id="focus-product-search" class="dropdownsearchstyle"
                  [(ngModel)]="productSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onProductSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of productDropDown | assessmentSearch : productSearchText"
                  [value]="item.valueExp" (onSelectionChange)="onProductSelect($event,item)">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" *ngIf="isProductIfOthers">
              <div>
                <label id="product-if-others" for="email">
                  {{dynamicLabel['PRODUCT_IF_OTHERS'].fieldName}}&nbsp;
                </label> <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['PRODUCT_IF_OTHERS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PRODUCT_IF_OTHERS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input type="text" class="input-filed-continers" [(ngModel)]="qualityService.activity.productIfOthers"
                  [disabled]="message.isInitiationFrozen">
              </div>
            </div>

            <div class="col-md-3">
              <div>
                <!-- Sample Type -->
                <label id="sample-type" for="email">
                  {{dynamicLabel['SAMPLE_TYPE'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['SAMPLE_TYPE']?.fieldNotes"
                  [matTooltip]="dynamicLabel['SAMPLE_TYPE']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <div class="row">
                <input class="input-filed-continers sampleType" type="text"
                  [matTooltip]="qualityService.activity.sampleType" [(ngModel)]="qualityService.activity.sampleType"
                  [disabled]="message.isInitiationFrozen">
              </div>
            </div>

            <div class="col-md-3">
              <div>
                <!-- Batch Type -->
                <label id="batch-type" for="email">
                  {{dynamicLabel['BATCH_TYPE'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['BATCH_TYPE']?.fieldNotes"
                  [matTooltip]="dynamicLabel['BATCH_TYPE']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <div class="row">
                <input class="input-filed-continers operatingUnit" type="text"
                  [matTooltip]="qualityService.activity.batchType" [(ngModel)]="qualityService.activity.batchType"
                  [disabled]="message.isInitiationFrozen">
              </div>
            </div>

            <div class="col-md-3">
              <div>
                <!--  Pack Details -->
                <label id="pack-details" for="email">
                  {{dynamicLabel['PACK_DETAILS'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['PACK_DETAILS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PACK_DETAILS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="input-filed-continers packDetails" type="text"
                  [matTooltip]="qualityService.activity.packDetails" [(ngModel)]="qualityService.activity.packDetails"
                  [disabled]="message.isInitiationFrozen">
              </div>
            </div>
          </div>
        </fieldset>

        <!-- Test Details -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Test Details</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-3">
              <div>
                <!-- Test Details -->
                <label id="test-details" for="email">
                  {{dynamicLabel['TEST_DETAILS'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['TEST_DETAILS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['TEST_DETAILS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="input-filed-continers" type="text" [disabled]="message.isInitiationFrozen"
                  [matTooltip]="qualityService.activity.testDetails" [(ngModel)]="qualityService.activity.testDetails"
                  (ngModelChange)="onNgModelChange(qualityService.activity.testDetails, 'test-details')">
              </div>
            </div>

            <div class="col-md-3">
              <div>
                <!-- Test Method -->
                <label id="test-method" for="email">
                  {{dynamicLabel['TEST_METHOD'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['TEST_METHOD']?.fieldNotes"
                  [matTooltip]="dynamicLabel['TEST_METHOD']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <div class="row">
                <input class="input-filed-continers" type="text" [disabled]="message.isInitiationFrozen"
                  [matTooltip]="qualityService.activity.testMethod" [(ngModel)]="qualityService.activity.testMethod"
                  (ngModelChange)="onNgModelChange(qualityService.activity.testMethod, 'test-method')">
              </div>
            </div>

            <div class="col-md-3">
              <div>
                <!-- Test Specification -->
                <label id="test-specification" for="email">
                  {{dynamicLabel['TEST_SPECIFICATION'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['TEST_SPECIFICATION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['TEST_SPECIFICATION']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="input-filed-continers" type="text" [disabled]="message.isInitiationFrozen"
                  [matTooltip]="qualityService.activity.testSpecification"
                  [(ngModel)]="qualityService.activity.testSpecification"
                  (ngModelChange)="onNgModelChange(qualityService.activity.testSpecification, 'test-specification')">
              </div>
            </div>
          </div>
        </fieldset>

        <!-- Instrument Details -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Instrument Details</span>
          </legend>
          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-3">
              <div>
                <!-- Instrument or Equipment Id -->
                <label id="instrument-id" for="email">
                  {{dynamicLabel['INSTRUMENT_OR_EQUIPMENT_ID'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['INSTRUMENT_OR_EQUIPMENT_ID']?.fieldNotes"
                  [matTooltip]="dynamicLabel['INSTRUMENT_OR_EQUIPMENT_ID']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="input-filed-continers instrumentOrEquipmentId" type="text"
                  [matTooltip]="qualityService.activity.instrumentOrEquipmentId"
                  [(ngModel)]="qualityService.activity.instrumentOrEquipmentId"
                  (ngModelChange)="onNgModelChange(qualityService.activity.instrumentOrEquipmentId, 'instrument-id')"
                  [disabled]="message.isInitiationFrozen">
              </div>
            </div>

            <div class="col-md-3">
              <div>
                <label id="instrument-name" for="email">
                  {{dynamicLabel['INSTRUMENT_OR_EQUIPMENT_NAME'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['INSTRUMENT_OR_EQUIPMENT_NAME']?.fieldNotes"
                  [matTooltip]="dynamicLabel['INSTRUMENT_OR_EQUIPMENT_NAME']?.fieldNotes"><img
                    [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <div class="row">
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [disabled]="message.isInitiationFrozen"
                  [(ngModel)]="qualityService.activity.instrumentOrEquipmentName"
                  (ngModelChange)="onNgModelChange(qualityService.activity.instrumentOrEquipmentName, 'instrument-name')"></textarea>
              </div>
            </div>
          </div>
        </fieldset>

        <!-- Observed Results -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Observed Results</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-6">
              <div>
                <label id="obtained-results" for="email">
                  {{dynamicLabel['OBTAINED_RESULTS'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['OBTAINED_RESULTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['OBTAINED_RESULTS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="input-filed-continers" type="text" [disabled]="message.isInitiationFrozen"
                  [matTooltip]="qualityService.activity.obtainedResults"
                  [(ngModel)]="qualityService.activity.obtainedResults"
                  (ngModelChange)="onNgModelChange(qualityService.activity.obtainedResults, 'obtained-results')">
              </div>
            </div>

            <div class="col-md-6">
              <div>
                <label id="concurrent-batch-results" for="email">
                  {{dynamicLabel['CONCURRENT_BATCHES_RESULTS'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['CONCURRENT_BATCHES_RESULTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['CONCURRENT_BATCHES_RESULTS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <textarea type="text" class="input-filed-textarea" [disabled]="message.isInitiationFrozen"
                  [matTooltip]="qualityService.activity.concurrentBatchesResults"
                  [(ngModel)]="qualityService.activity.concurrentBatchesResults"
                  (ngModelChange)="onNgModelChange(qualityService.activity.concurrentBatchesResults, 'concurrent-batch-results')">
                </textarea>
              </div>
            </div>

            <div class="col-md-6" [hidden]="dynamicLabel['AGREEMENT_WITH_OTHER_TESTS']?.isRemovable=='Y'">
              <div>
                <!-- Agreement with other tests -->
                <label id="agreement" for="email">
                  {{dynamicLabel['AGREEMENT_WITH_OTHER_TESTS']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['AGREEMENT_WITH_OTHER_TESTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['AGREEMENT_WITH_OTHER_TESTS']?.fieldNotes"><img
                    [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.agreementWithOtherTests" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isInitiationFrozen" (paste)="onPaste($event)"
                    (ngModelChange)="onStEditorChange(qualityService.activity.agreementWithOtherTests, 'agreement')"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isInitiationFrozen ? openEditor('Agreement with other tests', 'eye') : openEditor('Agreement with other tests', 'edit')"
                  (click)="message.isInitiationFrozen ? openEditor('Agreement with other tests', 'eye') : openEditor('Agreement with other tests', 'edit')">
                  <i *ngIf="!message.isInitiationFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isInitiationFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

            <div class="col-md-6" [hidden]="dynamicLabel['']?.isRemovable=='Y'">
              <div>
                <!-- Product or Material History -->
                <label id="product-history" for="email">
                  {{dynamicLabel['PRODUCT_OR_MATERIAL_HISTORY']?.fieldName}}
                  <span class="mandatory-symbol">*</span>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['PRODUCT_OR_MATERIAL_HISTORY']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PRODUCT_OR_MATERIAL_HISTORY']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.productOrMaterialHistory" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isInitiationFrozen" (paste)="onPaste($event)"
                    (ngModelChange)="onStEditorChange(qualityService.activity.productOrMaterialHistory, 'product-history')"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isInitiationFrozen ? openEditor(' Product or Material History', 'eye' ) : openEditor('Product or Material History', 'edit' )"
                  (click)="message.isInitiationFrozen ? openEditor(' Product or Material History', 'eye' ) : openEditor('Product or Material History', 'edit' )">
                  <i *ngIf="!message.isInitiationFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isInitiationFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

          </div>
        </fieldset>

        <!-- Laboratory Investigations -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Laboratory Investigations</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-2">
              <div>
                <!-- Is Analytical Lab Investigation Required? -->
                <label for="email">
                  {{dynamicLabel['IS_ANALYTICAL_LAB_INVESTIGATION_REQD']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['IS_ANALYTICAL_LAB_INVESTIGATION_REQD']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IS_ANALYTICAL_LAB_INVESTIGATION_REQD']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-slide-toggle color="primary" name="analytical-lab-investigation"
                [(ngModel)]="qualityService.activity.isAnalyticalLabInvestigationReqd"
                [disabled]="message.isInitiationFrozen">
                <ng-container *ngIf="qualityService.activity.isAnalyticalLabInvestigationReqd; else no">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>
            <div class="col-md-2">
              <!-- Is Microbiology Lab Investigation Required? -->
              <div>
                <label id="microbiology-lab-investigation" for="email">
                  {{dynamicLabel['IS_MICROBIOLOGY_LAB_INVESTIGATION_REQD'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['IS_MICROBIOLOGY_LAB_INVESTIGATION_REQD'].fieldNotes"
                  [matTooltip]="dynamicLabel['IS_MICROBIOLOGY_LAB_INVESTIGATION_REQD'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-slide-toggle color="primary" name="microbiology-lab-investigation"
                [(ngModel)]="qualityService.activity.isMicrobiologyLabInvestigationReqd"
                [disabled]="message.isInitiationFrozen">
                <ng-container *ngIf="qualityService.activity.isMicrobiologyLabInvestigationReqd; else no">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>
            <div class="col-md-2">
              <!-- Client Information Required? -->
              <div>
                <label id="client-intimation" for="email">
                  {{dynamicLabel['IS_CLIENT_INTIMATION_REQD'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['IS_CLIENT_INTIMATION_REQD'].fieldNotes"
                  [matTooltip]="dynamicLabel['IS_CLIENT_INTIMATION_REQD'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-slide-toggle color="primary" name="client-intimation"
                [(ngModel)]="qualityService.activity.isClientIntimationReqd" [disabled]="message.isInitiationFrozen">
                <ng-container *ngIf="qualityService.activity.isClientIntimationReqd; else no">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4"
              *ngIf="dynamicLabel['JUSTIFICATION_FOR_CLIENT_INTIMATION']?.isRemovable != 'Y' &&  qualityService.activity.isClientIntimationReqd">
              <div class="row">
                <label id="justification-client-info" for="email">
                  {{dynamicLabel['JUSTIFICATION_FOR_CLIENT_INTIMATION']?.fieldName}}
                  <span class="mandatory-symbol">*</span> </label>
                <span style="float:right" *ngIf="dynamicLabel['JUSTIFICATION_FOR_CLIENT_INTIMATION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['JUSTIFICATION_FOR_CLIENT_INTIMATION']?.fieldNotes"><img
                    [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.justificationForClientIntimation"
                    (ngModelChange)="onStEditorChange($event,'justification-client-info')" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isInitiationFrozen" (paste)="onPaste($event)"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isInitiationFrozen ? openEditor('justification For Client Intimation', 'eye') : openEditor('justification For Client Intimation', 'edit')"
                  (click)="message.isInitiationFrozen ? openEditor('justification For Client Intimation', 'eye') : openEditor('justification For Client Intimation', 'edit')">
                  <i *ngIf="!message.isInitiationFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isInitiationFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div>
                <!-- PHASE II Investigation Required? -->
                <label id="phase-II-investigation" for="email">
                  {{dynamicLabel['PHASEII_INVESTIGATION_REQD'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['PHASEII_INVESTIGATION_REQD'].fieldNotes"
                  [matTooltip]="dynamicLabel['PHASEII_INVESTIGATION_REQD'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-slide-toggle color="primary" name="phase-II-investigation"
                [(ngModel)]="qualityService.activity.phaseIIInvestigationReqd" [disabled]="true">
                <ng-container *ngIf="qualityService.activity.phaseIIInvestigationReqd; else no">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>
            <div class="col-md-2" *ngIf="qualityService.activity.phaseIIInvestigationReqd">
              <div>
                <!-- PHASE III Investigation Required? -->
                <label id="phase-III-investigation" for="email">
                  {{dynamicLabel['PHASEIII_INVESTIGATION_REQD'].fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['PHASEIII_INVESTIGATION_REQD'].fieldNotes"
                  [matTooltip]="dynamicLabel['PHASEIII_INVESTIGATION_REQD'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-slide-toggle color="primary" name="phase-III-investigation"
                [(ngModel)]="qualityService.activity.phaseIIIInvestigationReqd" [disabled]="true">
                <ng-container *ngIf="qualityService.activity.phaseIIIInvestigationReqd; else no">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>
          </div>
        </fieldset>

        <!-- Signatories -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Signatories</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-3" [hidden]="this.qualityService.activity.departmentHead==0">
              <div>
                <!-- Department Head -->
                <label id="department-head" for="email">
                  {{dynamicLabel['DEPARTMENT_HEAD_USER_NAME']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qualityService.activity.status,'dh')"
                  for="email">
                  <a (click)="openswitchuser('Department Head')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="switch" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEPARTMENT_HEAD_USER_NAME']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEPARTMENT_HEAD_USER_NAME']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="qualityService.activity.departmentHead"
                (closed)="departmentHeadSearchText=''" (click)="focusSearch('d-h-search')"
                (keydown.enter)="focusSearch('d-h-search')"
                [ngClass]="{'odd-item-mat-select':isDhOdd==qualityService.activity.departmentHead}"
                [disabled]="message.isInitiationFrozen">
                <input type="search" id="d-h-search" class="dropdownsearchstyle" [(ngModel)]="departmentHeadSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" (onSelectionChange)="onDepartmentHeadSelect($event, null)"
                  [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of departmentHeadDropDown| assessmentSearch :departmentHeadSearchText"
                  (onSelectionChange)="onDepartmentHeadSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" [hidden]="this.qualityService.activity.departmentHead==0">
              <div>
                <!-- Department Head -->
                <label id="oos-department-head" for="email">
                  {{dynamicLabel['OOS_DEPARTMENT_HEAD_NAME']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qualityService.activity.status,'oosDh')"
                  for="email">
                  <a (click)="openswitchuser('OOS Department Head')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="switch" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['OOS_DEPARTMENT_HEAD_NAME']?.fieldNotes"
                  [matTooltip]="dynamicLabel['OOS_DEPARTMENT_HEAD_NAME']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select" (keydown.enter)="focusSearch('o-d-h-search')"
                [(ngModel)]="qualityService.activity.oosDepartmentHead" (closed)="departmentHeadSearchText=''"
                (click)="focusSearch('o-d-h-search')"
                [ngClass]="{'odd-item-mat-select':isDhOdd==qualityService.activity.departmentHead}"
                [disabled]="message.isInitiationFrozen">
                <input type="search" id="o-d-h-search" class="dropdownsearchstyle"
                  [(ngModel)]="departmentHeadSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" (onSelectionChange)="onOosDepartmentHeadSelect($event,null)"
                  [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of departmentHeadDropDown| assessmentSearch :departmentHeadSearchText"
                  (onSelectionChange)="onOosDepartmentHeadSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div>
                <!-- QA -->
                <label id="qa-acceptance" for="email">
                  {{dynamicLabel['QA_ACCEPTANCE_USER_NAME'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qualityService.activity.status,'qaAc')"
                  for="email">
                  <a (click)="openswitchuser('QA Acceptance')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="switch" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['QA_ACCEPTANCE_USER_NAME'].fieldNotes"
                  [matTooltip]="dynamicLabel['QA_ACCEPTANCE_USER_NAME'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="qualityService.activity.qaAcceptance"
                (closed)="qaSearchText=''" (click)="focusSearch('qaa-search')"
                (keydown.enter)="focusSearch('qaa-search')" [disabled]="message.isInitiationFrozen"
                [ngClass]="{'odd-item-mat-select':isQaAcceptanceOdd==qualityService.activity.qaAcceptance}">
                <input type="search" id="qaa-search" class="dropdownsearchstyle" [(ngModel)]="qaSearchText" matInput
                  placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onQaAcceptanceSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of qaDropDown| assessmentSearch :qaSearchText"
                  (onSelectionChange)="onQaAcceptanceSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div>
                <!-- QA -->
                <label id="qa" for="email">
                  {{dynamicLabel['QA_USER_NAME'].fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <label *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qualityService.activity.status,'qa')"
                  id="owner-validation" for="email">
                  <a (click)="openswitchuser('QA')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="switch" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['QA_USER_NAME'].fieldNotes"
                  [matTooltip]="dynamicLabel['QA_USER_NAME'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="qualityService.activity.qa"
                (closed)="qaSearchText=''" (click)="focusSearch('qa-search')" (keydown.enter)="focusSearch('qa-search')"
                [ngClass]="{'odd-item-mat-select':isQaApproveOdd==qualityService.activity.qa}"
                [disabled]="message.isInitiationFrozen">
                <input type="search" id="qa-search" class="dropdownsearchstyle" [(ngModel)]="qaSearchText" matInput
                  placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onQaApproveSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of qaDropDown| assessmentSearch :qaSearchText"
                  (onSelectionChange)="onQaApproveSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-6" [hidden]="dynamicLabel['NOTIFY_TO_USERS']?.isRemovable=='Y'">
              <div>
                <label id="notify-to" for="notify-to">
                  {{dynamicLabel['NOTIFY_TO_USERS']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['NOTIFY_TO_USERS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['NOTIFY_TO_USERS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>

              <div class="row g-0">
                <div class="col-md-5 users-container">
                  <div class="file-list">
                    <span class="user-name" *ngFor="let user of selectedNotifyUsers; let i = index">
                      {{user.userName}}&nbsp;&nbsp;
                      <button class="remove-file-button" (click)="onUserRemoved(i, 'notify')"
                        matTooltip="Remove User">✕</button></span>
                  </div>
                </div>
                <div class="col-md-1 search-icon-div">
                  <button class="search-user" style="font-size: 1.3em" matTooltip="Search User(s)"
                    (click)="opensSearchUsersPopup('notify')" [disabled]="message.isInitiationFrozen">
                    <i class="fa fa-search"></i>
                  </button>
                  <button *ngIf="selectedNotifyUsers.length" matTooltip="Remove All User(s)" class="search-user"
                    style="font-size: 1.3em" (click)="removeAllUsers('notify')" [disabled]="message.isInitiationFrozen">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div>
                <label for="notify-to">
                  {{dynamicLabel['INVESTIGATION_TEAM_USERS']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['INVESTIGATION_TEAM_USERS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['INVESTIGATION_TEAM_USERS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>

              <div class="row g-0">
                <div class="col-md-5 users-container">
                  <div class="file-list">
                    <span class="user-name" *ngFor="let user of selectedInvestigationUsers; let i = index">
                      {{user.userName}}&nbsp;&nbsp;
                      <button class="remove-file-button" (click)="onUserRemoved(i, 'investigation')"
                        matTooltip="Remove User">✕</button></span>
                  </div>
                </div>
                <div class="col-md-1 search-icon-div">
                  <button class="search-user" style="font-size: 1.3em" matTooltip="Search User(s)"
                    (click)="opensSearchUsersPopup('investigation')" [disabled]="message.isInitiationFrozen">
                    <i class="fa fa-search"></i>
                  </button>
                  <button *ngIf="selectedInvestigationUsers.length" matTooltip="Remove All User(s)" class="search-user"
                    style="font-size: 1.3em" (click)="removeAllUsers('investigation')"
                    [disabled]="message.isInitiationFrozen">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset class="border p-2 crFieldsetStyle">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">More Info</span>
          </legend>
          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-2" *ngIf="qualityService.activity.lastActionOn">
              <div>
                <label for="email">
                  {{dynamicLabel['LAST_ACTION_ON']?.fieldName}}
                </label>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qualityService.activity.lastActionOn"
                [disabled]="true">
            </div>
            <div class="col-md-2" *ngIf="qualityService.activity.lastActionByUser">
              <div>
                <label for="email">
                  {{dynamicLabel['LAST_ACTION_BY_USER']?.fieldName}}
                </label>
              </div>
              <input type="text" class="input-filed-continers" [(ngModel)]="qualityService.activity.lastActionByUser"
                [disabled]="true">
            </div>
            <div class="col-md-2" *ngIf="qualityService.activity.lastActionComments">
              <div>
                <label for="email">
                  {{dynamicLabel['LAST_ACTION_COMMENTS']?.fieldName}}
                </label>
              </div>
              <input type="text" class="input-filed-continers" [(ngModel)]="qualityService.activity.lastActionComments"
                [disabled]="true">
            </div>
          </div>
        </fieldset>
        <div class="ActivityPage">
          <app-flexible-fields #flexible [from]="'Details'"></app-flexible-fields>
        </div>
      </div>
    </mat-tab>

    <div *ngFor="let tabPage of message.tabPagesOrderlist; let idx = index;">

      <mat-tab label="Phase II" label="Phase II" *ngIf="tabPage=='Phase II' && isPhaseII">
        <ng-template mat-tab-label>
          <span>
            <img src="/assets/img/two.png" alt="risk" width="20" height="20"></span> &nbsp;
          <span>Phase II</span>
        </ng-template>

        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Details</span>
          </legend>
          <div class="d-flex row ActivityPage" style="margin-top:1%;">
            <div class="col-md-6" *ngIf="dynamicLabel['JUSTIFICATION_OF_PHASEII']?.isRemovable != 'Y'">
              <div>
                <label id="p-2-justification" for="email">
                  {{dynamicLabel['JUSTIFICATION_OF_PHASEII']?.fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIL1Frozen" [(ngModel)]="qualityService.activity.justificationOfPhaseII"
                (ngModelChange)="onNgModelChange(qualityService.activity.justificationOfPhaseII, 'p-2-justification')"
                (input)="limitCharacters($event, 'JUSTIFICATION_OF_PHASEII')"></textarea>
            </div>

            <div class="col-md-6" *ngIf="dynamicLabel['PHASEII_OBJECTIVE_AND_APPROACH'].isRemovable != 'Y'">
              <div>
                <label id="p-2-objective" for="email">
                  {{dynamicLabel['PHASEII_OBJECTIVE_AND_APPROACH'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIL1Frozen" [(ngModel)]="qualityService.activity.phaseIIObjectiveAndApproach"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIObjectiveAndApproach, 'p-2-objective')"
                (input)="limitCharacters($event, 'PHASEII_OBJECTIVE_AND_APPROACH')"></textarea>
            </div>

            <ng-container
              *ngIf="qualityService.activity.status == 'PhaseII In Progress' || qualityService.activity.phaseIIOutcome">
              <div class="col-md-6" *ngIf="dynamicLabel['PHASEII_OUTCOME'].isRemovable != 'Y'">
                <div>
                  <label id="p-2-outcome" for="email">
                    {{dynamicLabel['PHASEII_OUTCOME'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [disabled]="message.isPhaseIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIOutcome"
                  (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIOutcome, 'p-2-outcome')"
                  (input)="limitCharacters($event, 'PHASEII_OUTCOME')"></textarea>
              </div>

              <div class="col-md-6" *ngIf="dynamicLabel['PHASEII_ROOTCAUSE_DETAILS'].isRemovable != 'Y'">
                <div>
                  <label id="p-2-root-cause" for="email">
                    {{dynamicLabel['PHASEII_ROOTCAUSE_DETAILS'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [disabled]="message.isPhaseIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIRootcauseDetails"
                  (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIRootcauseDetails, 'p-2-root-cause')"
                  (input)="limitCharacters($event, 'PHASEII_ROOTCAUSE_DETAILS')"></textarea>
              </div>

              <div class="col-md-6" *ngIf="dynamicLabel['PHASEII_CONCLUSION'].isRemovable != 'Y'">
                <div>
                  <label id="p-2-conclusion" for="email">
                    {{dynamicLabel['PHASEII_CONCLUSION'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [disabled]="message.isPhaseIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIConclusion"
                  (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIConclusion, 'p-2-conclusion')"
                  (input)="limitCharacters($event, 'PHASEII_CONCLUSION')"></textarea>
              </div>

            </ng-container>
          </div>
        </fieldset>

        <fieldset class="border p-2 field-set"
          *ngIf="qualityService.activity.status == 'PhaseII In Progress' || qualityService.activity.phaseIIOutcome">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Retesting</span>
          </legend>
          <div class="d-flex row ActivityPage" style="margin-top:1%;">
            <div class="col-md-2">
              <div>
                <label for="email">{{dynamicLabel['PHASEII_RETESTING_REQD'].fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['PHASEII_RETESTING_REQD'].fieldNotes"
                  [matTooltip]="dynamicLabel['PHASEII_RETESTING_REQD'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-slide-toggle color="primary" [(ngModel)]="qualityService.activity.phaseIIRetestingReqd"
                [disabled]="message.isPhaseIIL2Frozen">
                <span class="active-inActive-container" *ngIf="qualityService.activity.phaseIIRetestingReqd==true"
                  [ngStyle]="qualityService.activity.phaseIIRetestingReqd==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
                <span *ngIf="qualityService.activity.phaseIIRetestingReqd==false"
                  [ngStyle]="qualityService.activity.phaseIIRetestingReqd==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>

            <div class="col-md-4"
              *ngIf="qualityService.activity.phaseIIRetestingReqd && dynamicLabel['PHASEII_RETESTING_OBJECTIVE'].isRemovable != 'Y'">
              <div>
                <label id="p-2-r-objective" for="email">
                  {{dynamicLabel['PHASEII_RETESTING_OBJECTIVE'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIRetestingObjective"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIRetestingObjective, 'p-2-r-objective')"
                (input)="limitCharacters($event, 'PHASEII_RETESTING_OBJECTIVE')"></textarea>
            </div>

            <div class="col-md-6"
              *ngIf="qualityService.activity.phaseIIRetestingReqd && dynamicLabel['PHASEII_RETESTING_PLAN'].isRemovable != 'Y'">
              <div>
                <label id="p-2-r-plan" for="email">
                  {{dynamicLabel['PHASEII_RETESTING_PLAN'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIRetestingPlan"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIRetestingPlan, 'p-2-r-plan')"
                (input)="limitCharacters($event, 'PHASEII_RETESTING_PLAN')"></textarea>
            </div>

            <div class="col-md-3"
              *ngIf="qualityService.activity.phaseIIRetestingReqd && dynamicLabel['PHASEII_RETESTING_NUMBER_OF_ANALYST'].isRemovable != 'Y'">
              <div>
                <label id="p-2-r-no-of-analyst" for="email">
                  {{dynamicLabel['PHASEII_RETESTING_NUMBER_OF_ANALYST'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <input class="input-filed-continers" type="number" [disabled]="message.isPhaseIIL2Frozen"
                [(ngModel)]="qualityService.activity.phaseIIRetestingNumberOfAnalyst"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIRetestingNumberOfAnalyst, 'p-2-r-no-of-analyst')"
                (keypress)="validateNumberFields($event)">
            </div>

            <div class="col-md-3"
              *ngIf="qualityService.activity.phaseIIRetestingReqd && dynamicLabel['PHASEII_RETESTING_NUMBER_OF_ANALYSIS'].isRemovable != 'Y'">
              <div>
                <label id="p-2-r-no-of-analysis" for="email">
                  {{dynamicLabel['PHASEII_RETESTING_NUMBER_OF_ANALYSIS'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <input class="input-filed-continers" type="number" [disabled]="message.isPhaseIIL2Frozen"
                [(ngModel)]="qualityService.activity.phaseIIRetestingNumberOfAnalysis"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIRetestingNumberOfAnalysis, 'p-2-r-no-of-analysis')"
                (keypress)="validateNumberFields($event)">
            </div>

            <div class="col-md-6"
              *ngIf="qualityService.activity.phaseIIRetestingReqd && dynamicLabel['PHASEII_SUMMARY_OF_RETESTING_EXECUTION'].isRemovable != 'Y'">
              <div>
                <label id="p-2-summary-of-r-execution" for="email">
                  {{dynamicLabel['PHASEII_SUMMARY_OF_RETESTING_EXECUTION'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIL2Frozen"
                [(ngModel)]="qualityService.activity.phaseIISummaryOfRetestingExecution"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIISummaryOfRetestingExecution, 'p-2-summary-of-r-execution')"
                (input)="limitCharacters($event, 'PHASEII_SUMMARY_OF_RETESTING_EXECUTION')"></textarea>
            </div>

            <div class="col-md-6"
              *ngIf="qualityService.activity.phaseIIRetestingReqd && dynamicLabel['PHASEII_RETESTING_RESULTS'].isRemovable != 'Y'">
              <div>
                <label id="p-2-r-results" for="email">
                  {{dynamicLabel['PHASEII_RETESTING_RESULTS'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIRetestingResults"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIRetestingResults, 'p-2-r-results')"
                (input)="limitCharacters($event, 'PHASEII_RETESTING_RESULTS')"></textarea>
            </div>

            <div class="col-md-2"
              *ngIf="qualityService.activity.phaseIIRetestingReqd && dynamicLabel['PHASEII_IS_ROOT_CAUSE_IDENTIFIED_AT_RETESTING'].isRemovable != 'Y'">
              <div>
                <label for="email">{{dynamicLabel['PHASEII_IS_ROOT_CAUSE_IDENTIFIED_AT_RETESTING'].fieldName}}</label>
                <span style="float:right"
                  *ngIf="dynamicLabel['PHASEII_IS_ROOT_CAUSE_IDENTIFIED_AT_RETESTING'].fieldNotes"
                  [matTooltip]="dynamicLabel['PHASEII_IS_ROOT_CAUSE_IDENTIFIED_AT_RETESTING'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <mat-slide-toggle color="primary" [disabled]="message.isPhaseIIL2Frozen"
                [(ngModel)]="qualityService.activity.phaseIIIsRootCauseIdentifiedAtRetesting">
                <span class="active-inActive-container"
                  *ngIf="qualityService.activity.phaseIIIsRootCauseIdentifiedAtRetesting==true"
                  [ngStyle]="qualityService.activity.phaseIIIsRootCauseIdentifiedAtRetesting==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
                <span *ngIf="qualityService.activity.phaseIIIsRootCauseIdentifiedAtRetesting==false"
                  [ngStyle]="qualityService.activity.phaseIIIsRootCauseIdentifiedAtRetesting==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>

            <div class="col-md-4"
              *ngIf="qualityService.activity.phaseIIRetestingReqd && qualityService.activity.phaseIIIsRootCauseIdentifiedAtRetesting && dynamicLabel['PHASEII_RETESTING_ROOTCAUSE_DETAILS'].isRemovable != 'Y'">
              <div>
                <label id="p-2-r-root-cause" for="email">
                  {{dynamicLabel['PHASEII_RETESTING_ROOTCAUSE_DETAILS'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIL2Frozen"
                [(ngModel)]="qualityService.activity.phaseIIRetestingRootcauseDetails"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIRetestingRootcauseDetails, 'p-2-r-root-cause')"
                (input)="limitCharacters($event, 'PHASEII_RETESTING_ROOTCAUSE_DETAILS')"></textarea>
            </div>
          </div>
        </fieldset>
      </mat-tab>

      <mat-tab label="Phase III" label="Phase III" *ngIf="tabPage=='Phase III' && isPhaseIII">
        <ng-template mat-tab-label>
          <span>
            <img src="/assets/img/three.png" alt="risk" width="20" height="20"></span>&nbsp;
          <span>Phase III</span>
        </ng-template>
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Details</span>
          </legend>
          <div class="d-flex row ActivityPage" id="phase-3" style="margin-top:1%;">
            <div class="col-md-6" *ngIf="dynamicLabel['JUSTIFICATION_OF_PHASEIII'].isRemovable != 'Y'">
              <div>
                <label id="p-3-justification" for="email">
                  {{dynamicLabel['JUSTIFICATION_OF_PHASEIII'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIIL1Frozen" [(ngModel)]="qualityService.activity.justificationOfPhaseIII"
                (ngModelChange)="onNgModelChange(qualityService.activity.justificationOfPhaseIII, 'p-3-justification')"
                (input)="limitCharacters($event, 'JUSTIFICATION_OF_PHASEIII')"></textarea>
            </div>

            <div class="col-md-6" *ngIf="dynamicLabel['PHASEIII_OBJECTIVE_AND_APPROACH'].isRemovable != 'Y'">
              <div>
                <label id="p-3-objective" for="email">
                  {{dynamicLabel['PHASEIII_OBJECTIVE_AND_APPROACH'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIIL1Frozen"
                [(ngModel)]="qualityService.activity.phaseIIIObjectiveAndApproach"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIIObjectiveAndApproach, 'p-3-objective')"
                (input)="limitCharacters($event, 'PHASEIII_OBJECTIVE_AND_APPROACH')"></textarea>
            </div>

            <ng-container
              *ngIf="qualityService.activity.status == 'PhaseIII In Progress' || qualityService.activity.phaseIIIOutcome">
              <div class="col-md-6" *ngIf="dynamicLabel['PHASEIII_OUTCOME'].isRemovable != 'Y'">
                <div>
                  <label id="p-3-outcome" for="email">
                    {{dynamicLabel['PHASEIII_OUTCOME'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [disabled]="message.isPhaseIIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIIOutcome"
                  (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIIOutcome, 'p-3-outcome')"
                  (input)="limitCharacters($event, 'PHASEIII_OUTCOME')"></textarea>
              </div>

              <div class="col-md-6" *ngIf="dynamicLabel['PHASEIII_ROOTCAUSE_DETAILS'].isRemovable != 'Y'">
                <div>
                  <label id="p-3-root-cause" for="email">
                    {{dynamicLabel['PHASEIII_ROOTCAUSE_DETAILS'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [disabled]="message.isPhaseIIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIIRootcauseDetails"
                  (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIIRootcauseDetails, 'p-3-root-cause')"
                  (input)="limitCharacters($event, 'PHASEIII_ROOTCAUSE_DETAILS')"></textarea>
              </div>

              <div class="col-md-6" *ngIf="dynamicLabel['PHASEIII_CONCLUSION'].isRemovable != 'Y'">
                <div>
                  <label id="p-3-conclusion" for="email">
                    {{dynamicLabel['PHASEIII_CONCLUSION'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [disabled]="message.isPhaseIIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIIConclusion"
                  (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIIConclusion, 'p-3-conclusion')"
                  (input)="limitCharacters($event, 'PHASEIII_CONCLUSION')"></textarea>
              </div>
            </ng-container>
          </div>
        </fieldset>
        <fieldset class="border p-2 field-set"
          *ngIf="qualityService.activity.status == 'PhaseIII In Progress' || qualityService.activity.phaseIIIOutcome">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Retesting</span>
          </legend>
          <div class="d-flex row ActivityPage" style="margin-top:1%;">
            <div class="col-md-2">
              <div>
                <label for="email">{{dynamicLabel['PHASEIII_RETESTING_REQD'].fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['PHASEIII_RETESTING_REQD'].fieldNotes"
                  [matTooltip]="dynamicLabel['PHASEIII_RETESTING_REQD'].fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-slide-toggle color="primary" [(ngModel)]="qualityService.activity.phaseIIIRetestingReqd"
                [disabled]="message.isPhaseIIIL2Frozen">
                <span class="active-inActive-container" *ngIf="qualityService.activity.phaseIIIRetestingReqd==true"
                  [ngStyle]="qualityService.activity.phaseIIIRetestingReqd==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
                <span *ngIf="qualityService.activity.phaseIIIRetestingReqd==false"
                  [ngStyle]="qualityService.activity.phaseIIIRetestingReqd==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>

            <div class="col-md-6"
              *ngIf="qualityService.activity.phaseIIIRetestingReqd && dynamicLabel['PHASEIII_RETESTING_OBJECTIVE'].isRemovable != 'Y'">
              <div>
                <label id="p-3-r-objective" for="email">
                  {{dynamicLabel['PHASEIII_RETESTING_OBJECTIVE'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIIRetestingObjective"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIIRetestingObjective, 'p-3-r-objective')"
                (input)="limitCharacters($event, 'PHASEIII_RETESTING_OBJECTIVE')"></textarea>
            </div>

            <div class="col-md-3"
              *ngIf="qualityService.activity.phaseIIIRetestingReqd && dynamicLabel['PHASEIII_RETESTING_PLAN'].isRemovable != 'Y'">
              <div>
                <label id="p-3-r-plan" for="email">
                  {{dynamicLabel['PHASEIII_RETESTING_PLAN'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIIRetestingPlan"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIIRetestingPlan, 'p-3-r-plan')"
                (input)="limitCharacters($event, 'PHASEIII_RETESTING_PLAN')"></textarea>
            </div>

            <div class="col-md-3"
              *ngIf="qualityService.activity.phaseIIIRetestingReqd && dynamicLabel['PHASEIII_RETESTING_NUMBER_OF_ANALYST'].isRemovable != 'Y'">
              <div>
                <label id="p-3-r-no-of-analyst" for="email">
                  {{dynamicLabel['PHASEIII_RETESTING_NUMBER_OF_ANALYST'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <input class="input-filed-continers" type="number" [disabled]="message.isPhaseIIIL2Frozen"
                [(ngModel)]="qualityService.activity.phaseIIIRetestingNumberOfAnalyst"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIIRetestingNumberOfAnalyst, 'p-3-r-no-of-analyst')"
                (keypress)="validateNumberFields($event)">
            </div>

            <div class="col-md-3"
              *ngIf="qualityService.activity.phaseIIIRetestingReqd && dynamicLabel['PHASEIII_RETESTING_NUMBER_OF_ANALYSIS'].isRemovable != 'Y'">
              <div>
                <label id="p-3-r-no-of-analysis" for="email">
                  {{dynamicLabel['PHASEIII_RETESTING_NUMBER_OF_ANALYSIS'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <input class="input-filed-continers" type="number" [disabled]="message.isPhaseIIIL2Frozen"
                [(ngModel)]="qualityService.activity.phaseIIIRetestingNumberOfAnalysis"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIIRetestingNumberOfAnalysis, 'p-3-r-no-of-analysis')"
                (keypress)="validateNumberFields($event)">
            </div>

            <div class="col-md-6"
              *ngIf="qualityService.activity.phaseIIIRetestingReqd && dynamicLabel['PHASEIII_SUMMARY_OF_RETESTING_EXECUTION'].isRemovable != 'Y'">
              <div>
                <label id="p-3-summary-of-r-execution" for="email">
                  {{dynamicLabel['PHASEIII_SUMMARY_OF_RETESTING_EXECUTION'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIIL2Frozen"
                [(ngModel)]="qualityService.activity.phaseIIISummaryOfRetestingExecution"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIISummaryOfRetestingExecution, 'p-3-summary-of-r-execution')"
                (input)="limitCharacters($event, 'PHASEIII_SUMMARY_OF_RETESTING_EXECUTION')"></textarea>
            </div>

            <div class="col-md-6"
              *ngIf="qualityService.activity.phaseIIIRetestingReqd && dynamicLabel['PHASEIII_RETESTING_RESULTS'].isRemovable != 'Y'">
              <div>
                <label id="p-3-r-results" for="email">
                  {{dynamicLabel['PHASEIII_RETESTING_RESULTS'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIIL2Frozen" [(ngModel)]="qualityService.activity.phaseIIIRetestingResults"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIIRetestingResults, 'p-3-r-results')"
                (input)="limitCharacters($event, 'PHASEIII_RETESTING_RESULTS')"></textarea>
            </div>

            <div class="col-md-2"
              *ngIf="qualityService.activity.phaseIIIRetestingReqd && dynamicLabel['PHASEIII_IS_ROOT_CAUSE_IDENTIFIED_AT_RETESTING'].isRemovable != 'Y'">
              <div>
                <label for="email">
                  {{dynamicLabel['PHASEIII_IS_ROOT_CAUSE_IDENTIFIED_AT_RETESTING'].fieldName}}
                </label>
                <span style="float:right"
                  *ngIf="dynamicLabel['PHASEIII_IS_ROOT_CAUSE_IDENTIFIED_AT_RETESTING'].fieldNotes"
                  [matTooltip]="dynamicLabel['PHASEIII_IS_ROOT_CAUSE_IDENTIFIED_AT_RETESTING'].fieldNotes"><img
                    [src]="qualityService.noteIcon" alt="note" width="18" height="18"></span>
              </div>
              <mat-slide-toggle color="primary" [disabled]="message.isPhaseIIIL2Frozen"
                [(ngModel)]="qualityService.activity.phaseIIIIsRootCauseIdentifiedAtRetesting">
                <span class="active-inActive-container"
                  *ngIf="qualityService.activity.phaseIIIIsRootCauseIdentifiedAtRetesting==true"
                  [ngStyle]="qualityService.activity.phaseIIIIsRootCauseIdentifiedAtRetesting==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
                <span *ngIf="qualityService.activity.phaseIIIIsRootCauseIdentifiedAtRetesting==false"
                  [ngStyle]="qualityService.activity.phaseIIIIsRootCauseIdentifiedAtRetesting==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>

            <div class="col-md-4"
              *ngIf="qualityService.activity.phaseIIIRetestingReqd && qualityService.activity.phaseIIIIsRootCauseIdentifiedAtRetesting && dynamicLabel['PHASEIII_RETESTING_ROOTCAUSE_DETAILS'].isRemovable != 'Y'">
              <div>
                <label id="p-3-r-root-cause" for="email">
                  {{dynamicLabel['PHASEIII_RETESTING_ROOTCAUSE_DETAILS'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isPhaseIIIL2Frozen"
                [(ngModel)]="qualityService.activity.phaseIIIRetestingRootcauseDetails"
                (ngModelChange)="onNgModelChange(qualityService.activity.phaseIIIRetestingRootcauseDetails, 'p-3-r-root-cause')"
                (input)="limitCharacters($event, 'PHASEIII_RETESTING_ROOTCAUSE_DETAILS')"></textarea>
            </div>
          </div>
        </fieldset>
      </mat-tab>

      <mat-tab label="Analytical" *ngIf="tabPage=='Analytical' && isAnalytical">
        <ng-template mat-tab-label>
          <span>
            <img src="../../assets/img/analytical.svg" alt="analytical" width="20" height="20" class="ng-star-inserted">
          </span>&nbsp;
          <span>Analytical</span>
        </ng-template>
        <app-oos-questions *ngIf="selectedTab === 'Analytical'"></app-oos-questions>
      </mat-tab>

      <mat-tab label="Microbiology" *ngIf="tabPage=='Microbiology' && isMicrobiology">
        <ng-template mat-tab-label>
          <img src="../../assets/img/microbiology.svg" alt="microbiology" width="20" height="20"
            class="ng-star-inserted">&nbsp;
          <span>Microbiology</span>
        </ng-template>
        <app-oos-questions *ngIf="selectedTab === 'Microbiology'"></app-oos-questions>
      </mat-tab>

      <mat-tab label="Preliminary Actions" *ngIf="tabPage=='Preliminary Actions'">
        <ng-template mat-tab-label>
          <img src="../../assets/img/preliminary.svg" alt="preliminary-actions" width="20" height="20"
            class="ng-star-inserted">&nbsp;
          <span>Preliminary Actions</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Preliminary Actions" style="margin-top:1%;" *ngIf="dynamicLabel">
          <div class="row">
            <div class="col-md-6">
              <div>
                <!-- Delay Logging -->
                <label id="sequence" for="email">
                  {{dynamicLabel['SEQUENCE_OF_EVENTS']?.fieldName}}
                </label>
                <span class="mandatory-symbol" *ngIf="getPreliminaryMandatory()">*</span>
                <span style="float:right" *ngIf="dynamicLabel['SEQUENCE_OF_EVENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['SEQUENCE_OF_EVENTS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.sequenceOfEvents"
                    (ngModelChange)="onStEditorChange($event,'sequence')" [config]="excludeButtons" [spellcheck]="true"
                    [disabled]="message.isPreliminaryFrozen" (paste)="onPaste($event)"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isPreliminaryFrozen ? openEditor('Sequence of Events', 'eye') : openEditor('Sequence of Events', 'edit')"
                  (click)="message.isPreliminaryFrozen ? openEditor('Sequence of Events', 'eye') : openEditor('Sequence of Events', 'edit')">
                  <i *ngIf="!message.isPreliminaryFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isPreliminaryFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div>
                <label id="immediate-action" for="email">
                  {{dynamicLabel['IMMEDIATE_ACTION']?.fieldName}}
                </label>
                <span class="mandatory-symbol" *ngIf="getPreliminaryMandatory()">*</span>
                <span style="float:right" *ngIf="dynamicLabel['IMMEDIATE_ACTION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMMEDIATE_ACTION']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.immediateAction"
                    (ngModelChange)="onStEditorChange($event,'immediate-action')" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isPreliminaryFrozen" (paste)="onPaste($event)"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isPreliminaryFrozen ? openEditor('Immediate Action', 'eye') : openEditor('Immediate Action', 'edit')"
                  (click)="message.isPreliminaryFrozen ? openEditor('Immediate Action', 'eye') : openEditor('Immediate Action', 'edit')">
                  <i *ngIf="!message.isPreliminaryFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isPreliminaryFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div>
                <!-- Delay Logging -->
                <label id="initial-impact" for="email">
                  {{dynamicLabel['INITIAL_IMPACT_ASSESSMENT']?.fieldName}}
                </label>
                <span class="mandatory-symbol" *ngIf="getPreliminaryMandatory()">*</span>
                <span style="float:right" *ngIf="dynamicLabel['INITIAL_IMPACT_ASSESSMENT']?.fieldNotes"
                  [matTooltip]="dynamicLabel['INITIAL_IMPACT_ASSESSMENT']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.initialImpactAssessment"
                    (ngModelChange)="onStEditorChange($event,'initial-impact')" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isPreliminaryFrozen" (paste)="onPaste($event)"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isPreliminaryFrozen ? openEditor('Initial Impact Assessment', 'eye') : openEditor('Initial Impact Assessment', 'edit')"
                  (click)="message.isPreliminaryFrozen ? openEditor('Initial Impact Assessment', 'eye') : openEditor('Initial Impact Assessment', 'edit')">
                  <i *ngIf="!message.isPreliminaryFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isPreliminaryFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Data Evaluation" *ngIf="tabPage=='Data Evaluation' && message.showDataEvaluationTab">
        <ng-template mat-tab-label>
          <img src="../../assets/img/evaluation.svg" alt="evaluation" width="20" height="20"
            class="ng-star-inserted">&nbsp;
          <span>Data Evaluation</span>
        </ng-template>
        <!-- Data Evaluation -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Data Evaluation </span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-6">
              <div>
                <label id="overall-investigation-conclusion" for="email">
                  {{dynamicLabel['OVERALL_INVESTIGATION_CONCLUSION']?.fieldName}}
                </label> <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['OVERALL_INVESTIGATION_CONCLUSION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['OVERALL_INVESTIGATION_CONCLUSION']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.overallInvestigationConclusion"
                    [config]="excludeButtons" [spellcheck]="true" (paste)="onPaste($event)"
                    (ngModelChange)="onStEditorChange($event,'overall-investigation-conclusion')"
                    [disabled]="message.isLevel1EvaluationFrozen"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isLevel1EvaluationFrozen ? openEditor('Overall Investigation Conclusion', 'eye') : openEditor('Overall Investigation Conclusion', 'edit')"
                  (click)="message.isLevel1EvaluationFrozen ? openEditor('Overall Investigation Conclusion', 'eye') : openEditor('Overall Investigation Conclusion', 'edit')">
                  <i *ngIf="!message.isLevel1EvaluationFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isLevel1EvaluationFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div>
                <label id="overall-root-cause" for="email">
                  {{dynamicLabel['OVERALL_ROOTCAUSE_DETAILS']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['OVERALL_ROOTCAUSE_DETAILS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['OVERALL_ROOTCAUSE_DETAILS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.overallRootcauseDetails"
                    (ngModelChange)="onStEditorChange($event,'overall-root-cause')" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isLevel1EvaluationFrozen"
                    (paste)="onPaste($event)"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isLevel1EvaluationFrozen ? openEditor('Overall RootCause Details', 'eye') : openEditor('Overall RootCause Details', 'edit')"
                  (click)="message.isLevel1EvaluationFrozen ? openEditor('Overall RootCause Details', 'eye') : openEditor('Overall RootCause Details', 'edit')">
                  <i *ngIf="!message.isLevel1EvaluationFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isLevel1EvaluationFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Impact Assessment</span>
          </legend>
          <div class="row field-styles1 pop-out-box" style="margin-top: -1%;">
            <app-impact-assessment></app-impact-assessment>
          </div>
        </fieldset>

        <!-- CAPA -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">CAPA</span>
          </legend>
          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-2">
              <div>
                <label for="email">
                  {{dynamicLabel['IS_CAPA_REQD']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['IS_CAPA_REQD']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IS_CAPA_REQD']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-slide-toggle color="primary" name="analytical-lab-investigation"
                [(ngModel)]="qualityService.activity.isCapaReqd" [disabled]="message.isLevel1EvaluationFrozen">
                <ng-container *ngIf="qualityService.activity.isCapaReqd; else no">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>

            <div class="col-md-4" *ngIf="qualityService.activity.isCapaReqd">
              <div>
                <!-- Delay Logging -->
                <label id="capa-details" for="email">
                  {{dynamicLabel['CAPA_DETAILS']?.fieldName}}
                </label> <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['CAPA_DETAILS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['CAPA_DETAILS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="col-sm-11">
                  <input class="input-filed-continers" type="text" [matTooltip]="qualityService.activity.capaDetails"
                    [disabled]="message.isLevel1EvaluationFrozen" [(ngModel)]="qualityService.activity.capaDetails">
                </div>
                <div class="col-sm-1 search-icon-div">
                  <button class="search-user" style="font-size: 1.3em" matTooltip="Add or Map CAPA" (click)="mapCapa()"
                    *ngIf="!qualityService.activity.capaDetails" [disabled]="message.isLevel1EvaluationFrozen">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="search-user" style="font-size: 1.3em" matTooltip="Unmap CAPA" (click)="unmapCapa()"
                    *ngIf="qualityService.activity.capaDetails" [disabled]="message.isLevel1EvaluationFrozen">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-4" *ngIf="qualityService.activity.isCapaReqd">
              <div>
                <label id="capa-justification" for="email">
                  {{ dynamicLabel['JUSTIFICATION_FOR_CAPA_IMPLIMENTATION']?.fieldName }}
                </label> <span class="mandatory-symbol">*</span>
                <span style="float: right" *ngIf="dynamicLabel['JUSTIFICATION_FOR_CAPA_IMPLIMENTATION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['JUSTIFICATION_FOR_CAPA_IMPLIMENTATION']?.fieldNotes">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.justificationForCapaImplementation"
                    (ngModelChange)="onStEditorChange($event,'capa-justification')" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isLevel1EvaluationFrozen" (paste)="onPaste($event)">
                  </st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isLevel1EvaluationFrozen ? openEditor('Justification for Capa implementation', 'eye') : openEditor('Justification for Capa implementation', 'edit')"
                  (click)="message.isLevel1EvaluationFrozen ? openEditor('Justification for Capa implementation', 'eye') : openEditor('Justification for Capa implementation', 'edit')">
                  <i *ngIf="!message.isLevel1EvaluationFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isLevel1EvaluationFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

          </div>
        </fieldset>

        <!-- QA Overview -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span style="font-size: 14px; color: #cfcfcf;">QA overview</span>
          </legend>
          <div class="row field-styles1" style="margin-top: -1%;">
            <!-- overall conclusion -->
            <div class="col-md-5">
              <div>
                <label id="overall-conclusion" for="email">
                  {{ dynamicLabel['OVERALL_CONCLUSION']?.fieldName }}
                </label> <span class="mandatory-symbol">*</span>
                <span style="float: right" *ngIf="dynamicLabel['OVERALL_CONCLUSION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['OVERALL_CONCLUSION']?.fieldNotes">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.overallConclusion"
                    (ngModelChange)="onStEditorChange($event,'overall-conclusion')" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isLevel2EvaluationFrozen" (paste)="onPaste($event)">
                  </st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isLevel2EvaluationFrozen ? openEditor('Overall Conclusion', 'eye') : openEditor('Overall Conclusion', 'edit')"
                  (click)="message.isLevel2EvaluationFrozen ? openEditor('Overall Conclusion', 'eye') : openEditor('Overall Conclusion', 'edit')">
                  <i *ngIf="!message.isLevel2EvaluationFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isLevel2EvaluationFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

            <!-- Is Recurring -->
            <div class="col-md-2">
              <div>
                <label for="email">
                  {{ dynamicLabel['IS_RECURRING']?.fieldName }}
                </label>
                <span style="float: right" *ngIf="dynamicLabel['IS_RECURRING']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IS_RECURRING']?.fieldNotes">
                </span>
              </div>
              <mat-slide-toggle color="primary" name="recurring-required"
                [(ngModel)]="qualityService.activity.isRecurring" [disabled]="message.isLevel2EvaluationFrozen">
                <ng-container *ngIf="qualityService.activity.isRecurring; else no">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>
            <!-- Justification for Recurring (visible only if isRecurring is true) -->
            <div class="col-md-5" *ngIf="qualityService.activity.isRecurring">
              <div>
                <label id="recurring-justification" for="email">
                  {{ dynamicLabel['JUSTIFICATION_FOR_RECURRING']?.fieldName }}
                </label> <span class="mandatory-symbol">*</span>
                <span style="float: right" *ngIf="dynamicLabel['JUSTIFICATION_FOR_RECURRING']?.fieldNotes"
                  [matTooltip]="dynamicLabel['JUSTIFICATION_FOR_RECURRING']?.fieldNotes">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="qualityService.activity.justificationForRecurring"
                    (ngModelChange)="onStEditorChange($event,'recurring-justification')" [config]="excludeButtons"
                    [spellcheck]="true" [disabled]="message.isLevel2EvaluationFrozen" (paste)="onPaste($event)">
                  </st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit"
                  (keydown.enter)="message.isLevel2EvaluationFrozen ? openEditor('justification for recurring', 'eye') : openEditor('justification for recurring', 'edit')"
                  (click)="message.isLevel2EvaluationFrozen ? openEditor('justification for recurring', 'eye') : openEditor('justification for recurring', 'edit')">
                  <i *ngIf="!message.isLevel2EvaluationFrozen" class="far fa-edit"></i>
                  <i *ngIf="message.isLevel2EvaluationFrozen" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

            <div class="col-md-5"
              *ngIf="qualityService.activity.isRecurring && dynamicLabel['RECURRING_REFERENCES']?.isRemovable != 'Y'">
              <div>
                <label id="recurring-references" for="email">
                  {{ dynamicLabel['RECURRING_REFERENCES']?.fieldName }}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [disabled]="message.isLevel2EvaluationFrozen" [(ngModel)]="qualityService.activity.recurringReferences"
                (ngModelChange)="onNgModelChange($event,'recurring-references')"
                (input)="limitCharacters($event, 'JUSTIFICATION_OF_PHASEII')">
             </textarea>
            </div>
          </div>
        </fieldset>
      </mat-tab>

      <mat-tab label="Batch Disposition & Closure"
        *ngIf="tabPage=='Batch Disposition & Closure' && message.showClosureTab">
        <ng-template mat-tab-label>
          <img src="../../assets/img/seal-exclamation.svg" alt="closure" width="20" height="20"
            class="ng-star-inserted">&nbsp;
          <span>Batch Disposition & Closure</span>
        </ng-template>
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span style="font-size: 14px; color: #cfcfcf;">Batch Disposition</span>
          </legend>
          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-3" [hidden]="dynamicLabel['BATCH_DISPOSITION'].isRemovable=='Y'">
              <div>
                <label id="batch-disposition" for="email">
                  {{dynamicLabel['BATCH_DISPOSITION'].fieldName}}
                </label> <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['BATCH_DISPOSITION'].fieldNotes"
                  [matTooltip]="dynamicLabel['BATCH_DISPOSITION'].fieldNotes">
                </span>
              </div>
              <mat-select matInput placeholder="Select" (keydown.enter)="focusSearch('batch-disposition-search')"
                [(ngModel)]="qualityService.activity.batchDisposition" [disabled]="message.isClosureFrozen"
                (closed)="batchDispositionSearchText=''" (click)="focusSearch('batch-disposition-search')">
                <input type="search" id="batch-disposition-search" class="dropdownsearchstyle"
                  [(ngModel)]="batchDispositionSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onBatchDispositionSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of batchDispositionDropdown | assessmentSearch :batchDispositionSearchText"
                  (onSelectionChange)="onBatchDispositionSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>


            <div class="col-md-9 pl-3"
              *ngIf="isBatchRejectReason && dynamicLabel['BATCH_DISPOSITION'].isRemovable != 'Y'">
              <div>
                <label id="batch-reject" for="email">
                  {{dynamicLabel['BATCH_REJECTION_JUSTIFICATION'].fieldName}}&nbsp;
                </label> <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['BATCH_REJECTION_JUSTIFICATION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['BATCH_REJECTION_JUSTIFICATION']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input type="text" class="input-filed-continers" [disabled]="message.isClosureFrozen"
                  [(ngModel)]="qualityService.activity.batchRejectionJustification"
                  (ngModelChange)="onNgModelChange($event,'batch-reject')" [disabled]="message.isClosureFrozen">
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span style="font-size: 14px; color: #cfcfcf;">Closure</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <!-- CAPA Verification -->
            <div class="col-md-6">
              <div>
                <label id="capa-verification" for="email">
                  {{dynamicLabel['CAPA_VERIFICATION']?.fieldName}}
                </label> <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50" [disabled]="message.isClosureFrozen"
                [(ngModel)]="qualityService.activity.capaVerification"
                (ngModelChange)="onNgModelChange($event,'capa-verification')"
                (input)="limitCharacters($event, 'CAPA_VERIFICATION')">
            </textarea>
            </div>

            <!-- Closure Comments -->
            <div class="col-md-6">
              <div>
                <label id="closure-comments" for="email">
                  {{dynamicLabel['CLOSURE_COMMENTS']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50" [disabled]="message.isClosureFrozen"
                [(ngModel)]="qualityService.activity.closureComments"
                (ngModelChange)="onNgModelChange($event,'closure-comments')"
                (input)="limitCharacters($event, 'CLOSURE_COMMENTS')">
            </textarea>
            </div>
          </div>
        </fieldset>

        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span style="font-size: 14px; color: #cfcfcf;">Addendum</span>
          </legend>
          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-12">
              <div><label id="closure-validation" for="email">{{dynamicLabel['ADDENDUM']?.fieldName}}</label></div>
              <textarea type="text" class="input-filed-textarea" rows="4" cols="50" [disabled]="message.isClosureFrozen"
                [(ngModel)]="qualityService.activity.addendum" (input)="limitCharacters($event, 'ADDENDUM')"></textarea>
            </div>
          </div>
        </fieldset>
      </mat-tab>

      <mat-tab label="Actions" *ngIf=" tabPage=='Actions'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 8.99947H5.6L7.4364 3L11.3944 15.6L12.7913 8.99947H16.4" stroke="#0F3659"
                stroke-linecap="round" stroke-linejoin="round"
                [ngStyle]="{strokeWidth: selectedTab == 'Actions' ? '2' : ''}" />
            </svg> </span>&nbsp;
          <span>Actions</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Actions" style="margin-top:1%;">
          <app-oos-actions *ngIf="selectedTab === 'Actions'" (valueChange)="on_action_emit($event)"
            [activityData]="true"></app-oos-actions>
        </div>
      </mat-tab>

      <mat-tab label="Workflow" *ngIf="parallelWorkflowList.length &&  tabPage=='Parallel Workflow'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.3272 2.32701L11.6808 1.97346V1.97346L11.3272 2.32701ZM13.8728 4.8726L13.5192 5.22615L13.8728 4.8726ZM7.44645 12.3534C7.64172 12.5486 7.9583 12.5486 8.15356 12.3534C8.34882 12.1581 8.34882 11.8415 8.15356 11.6462L7.44645 12.3534ZM6.30001 10.4998L5.94645 10.1462C5.85268 10.24 5.80001 10.3672 5.80001 10.4998C5.80001 10.6324 5.85268 10.7596 5.94645 10.8534L6.30001 10.4998ZM8.15356 9.35336C8.34882 9.15809 8.34882 8.84151 8.15356 8.64625C7.9583 8.45099 7.64172 8.45099 7.44645 8.64625L8.15356 9.35336ZM10.5536 8.64625C10.3583 8.45099 10.0417 8.45099 9.84645 8.64625C9.65119 8.84151 9.65119 9.15809 9.84645 9.35336L10.5536 8.64625ZM11.7 10.4998L12.0536 10.8534C12.2488 10.6581 12.2488 10.3415 12.0536 10.1462L11.7 10.4998ZM9.84645 11.6463C9.65119 11.8415 9.65119 12.1581 9.84645 12.3534C10.0417 12.5486 10.3583 12.5486 10.5536 12.3534L9.84645 11.6463ZM12.6 15.6998H5.40001V16.6998H12.6V15.6998ZM4.10001 14.3998V3.5998H3.10001V14.3998H4.10001ZM5.40001 2.2998H10.0544V1.2998H5.40001V2.2998ZM13.9 6.14539V14.3998H14.9V6.14539H13.9ZM10.0544 2.2998C10.3992 2.2998 10.7299 2.43677 10.9737 2.68057L11.6808 1.97346C11.2494 1.54213 10.6644 1.2998 10.0544 1.2998V2.2998ZM5.40001 15.6998C4.68204 15.6998 4.10001 15.1178 4.10001 14.3998H3.10001C3.10001 15.6701 4.12975 16.6998 5.40001 16.6998V15.6998ZM12.6 16.6998C13.8703 16.6998 14.9 15.6701 14.9 14.3998H13.9C13.9 15.1178 13.318 15.6998 12.6 15.6998V16.6998ZM13.5192 5.22615C13.763 5.46995 13.9 5.80061 13.9 6.14539H14.9C14.9 5.53539 14.6577 4.95038 14.2264 4.51904L13.5192 5.22615ZM4.10001 3.5998C4.10001 2.88183 4.68204 2.2998 5.40001 2.2998V1.2998C4.12975 1.2998 3.10001 2.32955 3.10001 3.5998H4.10001ZM9.40001 1.7998V5.3998H10.4V1.7998H9.40001ZM10.8 6.7998H14.4V5.7998H10.8V6.7998ZM9.40001 5.3998C9.40001 6.173 10.0268 6.7998 10.8 6.7998V5.7998C10.5791 5.7998 10.4 5.62072 10.4 5.3998H9.40001ZM10.9737 2.68057L13.5192 5.22615L14.2264 4.51904L11.6808 1.97346L10.9737 2.68057ZM8.15356 11.6462L6.65356 10.1462L5.94645 10.8534L7.44645 12.3534L8.15356 11.6462ZM6.65356 10.8534L8.15356 9.35336L7.44645 8.64625L5.94645 10.1462L6.65356 10.8534ZM9.84645 9.35336L11.3465 10.8534L12.0536 10.1462L10.5536 8.64625L9.84645 9.35336ZM11.3465 10.1462L9.84645 11.6463L10.5536 12.3534L12.0536 10.8534L11.3465 10.1462Z"
                fill="#0F3659" stroke="#0F3659"
                [ngStyle]="{strokeWidth: selectedTab == 'Extension' ? '0.65' : '0.25'}" />
            </svg> </span>&nbsp;
          <span>Parallel Workflow</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Workflow" style="margin-top:1%;">
          <app-parallel-workflow *ngIf="selectedTab === 'Workflow'" [showGrid]="true"></app-parallel-workflow>
        </div>
      </mat-tab>

      <mat-tab label="Documents" *ngIf="message.showDocumentSection  && tabPage=='Files'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.2501 1.80005V4.50005C11.2501 4.99711 11.6531 5.40005 12.1501 5.40005H14.8501M6.30014 5.40005H8.10014M6.30014 8.10005H11.7001M6.30014 10.8H11.7001M13.5001 3.15005C13.0996 2.79165 12.6839 2.36658 12.4215 2.09051C12.2469 1.9068 12.0057 1.80005 11.7522 1.80005H4.94993C3.95582 1.80005 3.14993 2.60593 3.14993 3.60004L3.14986 14.4C3.14985 15.3941 3.95573 16.2 4.94985 16.2L13.0499 16.2C14.044 16.2 14.8499 15.3942 14.8499 14.4001L14.8501 4.85842C14.8501 4.62829 14.7623 4.40708 14.6026 4.2414C14.3073 3.93503 13.8141 3.43094 13.5001 3.15005Z"
                stroke="#005C8A" [ngStyle]="{strokeWidth: selectedTab == 'Documents' ? '2' : ''}" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg> </span>&nbsp;
          <span>Files</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Documents" style="margin-top:1%;">
          <app-task-documents (valueChange)="on_documents_emit($event)" *ngIf="selectedTab === 'Documents'"
            [activity]="docObj"></app-task-documents>
        </div>
      </mat-tab>

      <mat-tab label="Reviewer/Approver"
        *ngIf="message.showReviewApproveSection && !isStageUsersSkipped && tabPage=='Reviewer/Approver'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.72486 16.2H4.12485C3.13074 16.2 2.32485 15.3941 2.32486 14.4L2.32493 3.60004C2.32494 2.60593 3.13082 1.80005 4.12493 1.80005H12.2251C13.2192 1.80005 14.0251 2.60594 14.0251 3.60005V8.55005M10.4251 13.65L12.0751 15.3L15.6751 11.6999M5.47514 5.40005H10.8751M5.47514 8.10005H10.8751M5.47514 10.8H8.17514"
                stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
                [ngStyle]="{strokeWidth: selectedTab == 'Reviewer/Approver' ? '2' : ''}" />
            </svg> </span>&nbsp;
          <span>Reviewer/Approver</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Reviewers/Approvers" style="margin-top:1%;">
          <app-stageusers *ngIf="selectedTab === 'Reviewer/Approver'" (valueChange)="on_stageUser_emit($event)"
            [activityData]="this.qualityService.activity"></app-stageusers>
        </div>
      </mat-tab>

      <mat-tab label="Effectiveness Check" *ngIf="message.showEffectiveSection && tabPage=='Effectiveness Check'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.7 7.19981L7.67277 10.7998L6.3 9.57266M16.2 4.4998L16.2 13.4999C16.2 14.9911 14.9912 16.1999 13.5 16.1999H4.5C3.00883 16.1999 1.8 14.9911 1.8 13.4999V4.4998C1.8 3.00864 3.00883 1.7998 4.5 1.7998H13.5C14.9912 1.7998 16.2 3.00864 16.2 4.4998Z"
                stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
                [ngStyle]="{strokeWidth: selectedTab == 'Effectiveness Check' ? '2' : ''}" />
            </svg> </span>&nbsp;
          <span>Effectiveness Check</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Effectiveness Check" style="margin-top:1%;">
          <app-tasks-ec (valueChange)="on_effectiveness_emit($event)" *ngIf="selectedTab === 'Effectiveness Check'"
            [activityData]="true"></app-tasks-ec>
        </div>
      </mat-tab>

      <mat-tab label="Extension" *ngIf="message.showExtensionSection && tabPage=='Extension'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.3272 2.32701L11.6808 1.97346V1.97346L11.3272 2.32701ZM13.8728 4.8726L13.5192 5.22615L13.8728 4.8726ZM7.44645 12.3534C7.64172 12.5486 7.9583 12.5486 8.15356 12.3534C8.34882 12.1581 8.34882 11.8415 8.15356 11.6462L7.44645 12.3534ZM6.30001 10.4998L5.94645 10.1462C5.85268 10.24 5.80001 10.3672 5.80001 10.4998C5.80001 10.6324 5.85268 10.7596 5.94645 10.8534L6.30001 10.4998ZM8.15356 9.35336C8.34882 9.15809 8.34882 8.84151 8.15356 8.64625C7.9583 8.45099 7.64172 8.45099 7.44645 8.64625L8.15356 9.35336ZM10.5536 8.64625C10.3583 8.45099 10.0417 8.45099 9.84645 8.64625C9.65119 8.84151 9.65119 9.15809 9.84645 9.35336L10.5536 8.64625ZM11.7 10.4998L12.0536 10.8534C12.2488 10.6581 12.2488 10.3415 12.0536 10.1462L11.7 10.4998ZM9.84645 11.6463C9.65119 11.8415 9.65119 12.1581 9.84645 12.3534C10.0417 12.5486 10.3583 12.5486 10.5536 12.3534L9.84645 11.6463ZM12.6 15.6998H5.40001V16.6998H12.6V15.6998ZM4.10001 14.3998V3.5998H3.10001V14.3998H4.10001ZM5.40001 2.2998H10.0544V1.2998H5.40001V2.2998ZM13.9 6.14539V14.3998H14.9V6.14539H13.9ZM10.0544 2.2998C10.3992 2.2998 10.7299 2.43677 10.9737 2.68057L11.6808 1.97346C11.2494 1.54213 10.6644 1.2998 10.0544 1.2998V2.2998ZM5.40001 15.6998C4.68204 15.6998 4.10001 15.1178 4.10001 14.3998H3.10001C3.10001 15.6701 4.12975 16.6998 5.40001 16.6998V15.6998ZM12.6 16.6998C13.8703 16.6998 14.9 15.6701 14.9 14.3998H13.9C13.9 15.1178 13.318 15.6998 12.6 15.6998V16.6998ZM13.5192 5.22615C13.763 5.46995 13.9 5.80061 13.9 6.14539H14.9C14.9 5.53539 14.6577 4.95038 14.2264 4.51904L13.5192 5.22615ZM4.10001 3.5998C4.10001 2.88183 4.68204 2.2998 5.40001 2.2998V1.2998C4.12975 1.2998 3.10001 2.32955 3.10001 3.5998H4.10001ZM9.40001 1.7998V5.3998H10.4V1.7998H9.40001ZM10.8 6.7998H14.4V5.7998H10.8V6.7998ZM9.40001 5.3998C9.40001 6.173 10.0268 6.7998 10.8 6.7998V5.7998C10.5791 5.7998 10.4 5.62072 10.4 5.3998H9.40001ZM10.9737 2.68057L13.5192 5.22615L14.2264 4.51904L11.6808 1.97346L10.9737 2.68057ZM8.15356 11.6462L6.65356 10.1462L5.94645 10.8534L7.44645 12.3534L8.15356 11.6462ZM6.65356 10.8534L8.15356 9.35336L7.44645 8.64625L5.94645 10.1462L6.65356 10.8534ZM9.84645 9.35336L11.3465 10.8534L12.0536 10.1462L10.5536 8.64625L9.84645 9.35336ZM11.3465 10.1462L9.84645 11.6463L10.5536 12.3534L12.0536 10.8534L11.3465 10.1462Z"
                fill="#0F3659" stroke="#0F3659"
                [ngStyle]="{strokeWidth: selectedTab == 'Extension' ? '0.65' : '0.25'}" />
            </svg> </span>&nbsp;
          <span>Extension</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Extensions" style="margin-top:1%;">
          <app-task-extensions (extension)="on_extension_emit($event)" *ngIf="selectedTab === 'Extension'"
            [activityData]="true"></app-task-extensions>
        </div>
      </mat-tab>

      <mat-tab label="Dependency" *ngIf="message.showDependancySection && tabPage=='Dependency'">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.05 7.36653L16.2 8.98115L8.99999 12.6717L1.79999 8.98115L5.00756 7.33702M13.05 10.8946L16.2 12.5092L8.99999 16.1998L1.79999 12.5092L5.00756 10.8651M8.99999 1.7998L16.2 5.49036L8.99999 9.18092L1.79999 5.49036L8.99999 1.7998Z"
                stroke="#0F3659" [ngStyle]="{strokeWidth: selectedTab == 'Dependancy' ? '2' : ''}"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg> </span>&nbsp;
          <span>Dependency</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Dependency" style="margin-top:1%;">
        </div>
      </mat-tab>

      <mat-tab label="Risk Assessment" *ngIf="message.showRiskTab && tabPage=='Risk Assessment'">
        <ng-template mat-tab-label>
          <span>
            <img src="../../assets/img/warning (1).png" alt="risk" width="20" height="20" class="ng-star-inserted">
          </span>&nbsp;
          <span>Risk Assessment</span>
        </ng-template>
        <div class="form-template ActivityPage" id="Risk Assessment" style="margin-top:1%;">
          <app-risk [pagename]="'activity'" *ngIf="selectedTab === 'Risk Assessment'"
            [isRiskFieldsActivited]="true"></app-risk>
        </div>
      </mat-tab>

      <mat-tab label="Notifications" *ngIf=" tabPage=='Notifications' && isAdditionalTabUser">
        <ng-template mat-tab-label>
          <span><i class="fa-solid fa-bell" style="font-size: 20px;"></i></span>&nbsp;
          <span>Notifications</span>
        </ng-template>
        <div class="form-template ActivityPage" style="margin-top:1%;">
          <app-activity-notifications *ngIf="selectedTab === 'Notifications'"></app-activity-notifications>
        </div>
      </mat-tab>

      <mat-tab label="History" *ngIf=" tabPage=='History' && isAdditionalTabUser">
        <ng-template mat-tab-label>
          <span>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.8875 10.7998L8.18755 9.8998V6.1365M15.3875 8.9998C15.3875 5.02335 12.164 1.7998 8.18755 1.7998C4.2111 1.7998 0.987549 5.02335 0.987549 8.9998C0.987549 12.9763 4.2111 16.1998 8.18755 16.1998C10.8526 16.1998 13.1794 14.7519 14.4243 12.5998M13.4124 8.20968L15.2124 10.0097L17.0124 8.20968"
                stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
                [ngStyle]="{strokeWidth: selectedTab == 'History' ? '2' : ''}" />
            </svg> </span>&nbsp;
          <span>History</span>
        </ng-template>
        <div class="form-template ActivityPage" style="margin-top:1%;">
          <app-task-history *ngIf="selectedTab === 'History'"></app-task-history>
        </div>
      </mat-tab>
    </div>
  </mat-tab-group>
</div>

<ng-template #searchUsersPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" (click)="cancelSearchUsersPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search User(s) </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 10px 20px;">
    <div class="row">
      <div class="col-md-4">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name" [(ngModel)]="uname">
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter First Name" [(ngModel)]="fname">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Last Name" [(ngModel)]="lname">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div><label for="email">Email</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Email" [(ngModel)]="email">
        <div id="email-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="designation" (closed)="designationSearchText=''"
          (click)=" focusSearch('designation')" (keydown.enter)="focusSearch('designation')">
          <input type="search" id="designation" class="dropdownsearchstyle" [(ngModel)]="designationSearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of designationDropDown | assessmentSearch :designationSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="department" (closed)="departmentSearchText=''"
          (click)="focusSearch('department-f')" (keydown.enter)="focusSearch('department-f')">
          <input type="search" id="department-f" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentDropDown| assessmentSearch :departmentSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row" style="margin-top: 5px;">
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="searchUsersFunc()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" *ngIf="!qualityUserList.length"
          (click)="cancelSearchUsersPopup()">
          <i class="fa fa-close"></i> Cancel
        </button>
        <button mat-stroked-button class="cancelButton"
          *ngIf="uname || fname || lname || email || designation || department || qualityUserList.length"
          (click)="resetSearchUsers()">
          <i class="fas fa-undo"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="qualityUserList.length">
      <table class="static-table-container" aria-describedby="table-description" style="height: 42vh;">
        <thead>
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input type="checkbox" style="zoom: 1.2;" [checked]="searchUserParentCheckBox"
                  (change)="onParentCheckBoxChanged($event)">
              </div>
            </div>
          </th>
          <th>
            <span>User Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>First Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Last Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Designation</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Department</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>EmailAddress</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Is Ad User</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th id="menu" class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let user of qualityUserList; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="user.searchUserChildCheckBox ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="selectedManagerCheckBox" type="checkbox" style="zoom: 1.2;"
                    [checked]="user.searchUserChildCheckBox" (change)="onChildCheckBoxChanged($event, user, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ user.userName }}</td>
            <td class="row-data">{{ user.firstName }}</td>
            <td class="row-data">{{ user.lastName }}</td>
            <td class="row-data">{{ user.designation }}</td>
            <td class="row-data">{{ user.department }}</td>
            <td class="row-data">{{ user.emailAddress }}</td>
            <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
                type="checkbox" [(ngModel)]="user.isAdUser">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="qualityUserList.length">
    <button mat-stroked-button class="addButton" (click)="getUsers()" [disabled]="!tempUsers.length">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchUsersPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" id="editor" class="popupTitle"> {{ this.editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? includeButtons : excludeButtons"
        (ngModelChange)="onStEditorChange($event,'editor')" [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button *ngIf="allowEditing" class="addButton" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #mandatoryPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>

  <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Mandatory Alert </label>
  </div>

  <div style="margin: 15px 15px;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <span style="font-weight: 500; font-size: larger;"> Please enter all Mandatory Fields
        <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
      </span>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
        Ok
      </button>
    </div>
  </div>
</ng-template>

<ng-template #openExportReportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" mat-button (click)="cancelExportPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Choose Report Template </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-container1">
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label id="report-template" for="email">Report Template</label>
        <span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportTemplate"
          (closed)="reportTemplateSearchText=''" (click)="focusSearch('focus-template-search')"
          (keydown.enter)="focusSearch('focus-template-search')">
          <input type="search" id="focus-template-search" class="dropdownsearchstyle"
            [(ngModel)]="reportTemplateSearchText" matInput placeholder="search">

          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onReportTemplateSelect($event, null)">Un-select</mat-option>

          <mat-option *ngFor="let item of reportTemplateDropDown | assessmentSearch : reportTemplateSearchText"
            (onSelectionChange)="onReportTemplateSelect($event, item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <br>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label id="logo" for="email">Report Logo</label>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogo" (closed)="reportLogoSearchText=''"
          (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="reportLogoSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : reportLogoSearchText"
            (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
          (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">

          <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>

    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Attach all documents?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="attachAllDocuments">
          <ng-container *ngIf="attachAllDocuments; else noattachAllDocuments">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noattachAllDocuments>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="attachAllDocuments">

      <label for="email">Attachments to the report are limited to PDF, DOC, or DOCX formats.</label>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="exportReport()">
      <i class="fas fa-check"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReport()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #alertPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>

  <button class="close close-button" (click)="closeAlertPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="alert" class="popupTitle"> Warning </label>
  </div>

  <div style="margin: 15px 15px;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <span style="font-weight: 500; font-size: larger;"> We noticed there are unsaved changes. <br>
        Do you wish to proceed without saving
        <span style="color: red; font-size: medium;"><i class="fa fa-question"></i></span>
      </span>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="closeAlertPopup(true)">Yes</button>
      <button mat-stroked-button class="cancelButton" (click)="closeAlertPopup(false)">No</button>
    </div>
  </div>
</ng-template>


<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
<app-add-parallel-workflows (valueEmitter)="onWorkflowChildValueEmitted()"
  *ngIf="addWorkflow"></app-add-parallel-workflows>
<app-add-map-capa (valueEmitter)="onCapaEmitted()"></app-add-map-capa>
<app-quality-dependents></app-quality-dependents>